import { useMemo } from 'react'
import { useConfirmDialog, useError } from '@ztechapps/common.hook'
import type { Adjustment } from '@ztechapps/common.contract'
import { AdjustmentStatusEnum } from '@ztechapps/common.contract'
import map from 'lodash/map'
import { AdjustmentStatus, useAdjustmentStateTransition } from '@ztechapps/adjustment.common'

type OnUpdate = (value: AdjustmentStatusEnum) => Promise<void>

export const useUpdateAdjustmentStatus = (adjustment: Adjustment) => {
  const status = adjustment?.status
  const adjustmentId = adjustment?._id
  const [{ changeStatus, moveToCancel }, { loading, error }] = useAdjustmentStateTransition()

  useError(error)

  const onCancel = () => {
    return moveToCancel(adjustmentId)
  }

  const { onConfirm: onCancelWithConfirmation } = useConfirmDialog({
    text: `This will cancel the adjustment and do the following!
    
     1. Adjustment will be locked for editing and will be archive.
     2. Inventory will be updated (if the current status is Complete)
     `,

    title: 'Cancel adjustment?',
    buttons: { confirm: { text: 'Yes, cancel it!' } },
    confirmed: onCancel,
  })

  const onUpdate: OnUpdate = async (value) => {
    //if tehre is no change, do nothing
    if (value === status) {
      return
    }

    //branch here for the selected status
    switch (value) {
      case AdjustmentStatusEnum.Cancelled:
        await onCancelWithConfirmation()
        break
      default:
        await changeStatus(value, adjustmentId)
        break
    }
  }

  const statusMenu = useMemo<{ value: string }[]>(() => {
    return map(AdjustmentStatus, (e) => ({ value: e.value }))
  }, [])

  return { onUpdate, statusMenu, loading, error }
}
